import usePage from "@/hooks/usePage";

export default function AdminHome() {
  const { props } = usePage<{ user: any } & CommonUsePageProps>();

  return (
    <>
      <div>Admin Home for User: {props.user.email}</div>
    </>
  );
}
